// extracted by mini-css-extract-plugin
export default {"dayItem":"day_dayItem__Xaik9","notAllowed":"day_notAllowed__-faTU","from":"day_from__L0KZs","to":"day_to__dJaKJ","selected":"day_selected__5025c","interval":"day_interval__6vx-K"};